<script setup lang="ts">
import { BadgeCheck, UserRound } from 'lucide-vue-next'

// A reader's question and a bank specialist's answer
const { t } = useI18n()
</script>

<template>
  <div class="relative w-[21rem] select-none space-y-3" aria-hidden="true">
    <div class="flex items-end gap-2">
      <span class="grid size-9 shrink-0 place-items-center rounded-full bg-white text-gray-400 ring-1 ring-blue-100">
        <UserRound class="size-5" />
      </span>
      <div class="rounded-2xl rounded-bl-sm bg-white px-4 py-3 text-sm font-semibold leading-5 shadow-sm ring-1 ring-blue-100">
        {{ t('widget.hero_banner.illustration.discussions.question') }}
      </div>
    </div>

    <div class="ml-8 rounded-2xl rounded-br-sm bg-blue-600 px-4 py-3 text-white shadow-[0_24px_48px_-24px_rgba(37,99,235,0.8)]">
      <div class="mb-1 flex items-center gap-1.5 text-xs font-semibold text-blue-100">
        <BadgeCheck class="size-4 text-yellow-300" />
        {{ t('widget.hero_banner.illustration.discussions.specialist') }}
      </div>
      <div class="text-sm leading-5">{{ t('widget.hero_banner.illustration.discussions.answer') }}</div>
    </div>

    <div class="ml-8 flex items-center gap-1 pl-1">
      <span class="size-2 animate-bounce rounded-full bg-blue-300 motion-reduce:animate-none" />
      <span class="size-2 animate-bounce rounded-full bg-blue-300 [animation-delay:150ms] motion-reduce:animate-none" />
      <span class="size-2 animate-bounce rounded-full bg-blue-300 [animation-delay:300ms] motion-reduce:animate-none" />
    </div>
  </div>
</template>
